// Note de la séance donnée par le moniteur dans le résumé de séance (J36, 28/10/2026) : elle porte sur l'attitude
// d'ensemble de l'élève pendant la séance, pas sur sa conduite, et elle est indicative. Dit à l'élève là où il la voit.

/** Légende des étoiles, sous les retours des moniteurs. */
export const SESSION_RATING_MEANING = 'Étoiles : note indicative de votre attitude d’ensemble pendant la séance, pas de votre conduite.';

/** Nom accessible des étoiles d'une séance. */
export const sessionRatingLabel = (rating: number) => `Attitude pendant la séance : ${rating} sur 5 (note indicative)`;
